class Accordion {
    stateClasses = {
        active: "active",
        visible: "accordion--visible"
    }

    constructor($el) {
        this.$el = $el;
        this.index = this.$el.data('index');
        this.$item = $(`[data-accordion="item"][data-index="${this.index}"]`);
        this.$close = this.$item.find('[data-accordion="close"]');

        this.init();
    }

    init = () => {
        this.$el.on('click', this.clickHandler);
        this.$close.on('click', this.close);
    }

    clickHandler = (e) => {

        if ($(e.target).closest('[data-accordion="item"]').length) {
            return;
        }
        const isVisible = this.$item.hasClass(this.stateClasses.visible);

        this.closeAll();

        if (!isVisible) {
            this.open();
        }
    }

    closeAll = () => {
        $('[data-accordion="item"]').removeClass(this.stateClasses.visible);
        $('[data-accordion="el"]').removeClass(this.stateClasses.active);
        $('[data-accordion="el"]').css('padding-bottom', '');
    }

    close = () => {

        this.$item.removeClass(this.stateClasses.visible);
        this.$el.removeClass(this.stateClasses.active);
        this.$el.css('padding-bottom', '');
    }

    open = () => {
        const size = this.$item.innerHeight();
        this.$item.addClass(this.stateClasses.visible);
        this.$el.addClass(this.stateClasses.active);
        this.$el.css('padding-bottom', `${size}px`);
    }
}

export default Accordion;
